import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_SERVER + process.env.VUE_APP_BACKEND_DIRECTORY,
  withCredentials: true
})
Vuex.Store.prototype.$http = axiosInstance

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    user: null,
    errorMessage: '',
    connectors: [],
    suppliers: [],
    loadingUser: false,
    loadingSuppliers: false
  },
  mutations: {
    userSuccess (state, user) {
      state.user = user
      state.errorMessage = ''
      state.loadingUser = false
    },
    userError (state, errorMessage) {
      state.user = null
      state.errorMessage = errorMessage
      state.loadingUser = false
    },
    userLogout (state) {
      state.user = null
      state.errorMessage = ''
      state.loadingUser = false
    },
    userIsLoading (state) {
      state.loadingUser = true
      state.errorMessage = ''
    },
    connectorLoad (state, items) {
      state.connectors = items
    },
    supplierLoad (state, items) {
      state.suppliers = items
      state.loadingSuppliers = false
    },
    supplierIsLoading (state) {
      state.loadingSuppliers = true
    }
  },
  actions: {
    me ({ commit, dispatch }) {
      this.$http.get('/me')
        .then(response => {
          if (response.status === 200) {
            commit('userSuccess', response.data)
            dispatch('getSuppliers')
          }
        })
    },
    login ({ commit, dispatch }, { email, password }) {
      commit('userIsLoading')
      this.$http.post('/login', { email, password })
        .then(response => {
          switch (response.status) {
            case 204:
              dispatch('me')
              break
            default:
              commit('userError', response.error)
              break
          }
        })
        .catch(error => {
          if (!error.response) {
            commit('userError', error.message)
          } else {
            commit('userError', error.response.data.error)
          }
        })
    },
    logout ({ commit }) {
      commit('userIsLoading')
      this.$http.get('/logout')
        .catch(error => {
          if (!error.response) {
            commit('userError', error.message)
          } else {
            commit('userError', error.response.data.error)
          }
        })
        .finally(() => {
          commit('userLogout')
        })
    },
    getSuppliers ({ commit }) {
      commit('supplierIsLoading')
      this.$http('/suppliers/connectors')
        .then(response => {
          commit('connectorLoad', response.data['hydra:member'])
          return this.$http('/suppliers', {
            params: {
              pagination: false
            }
          })
        })
        .then(response => {
          commit('supplierLoad', response.data['hydra:member'])
        })
        .catch(error => {
          if (!error.response) {
            commit('userError', error.message)
          } else {
            commit('userError', error.response.data.error)
          }
        })
    }
  },
  getters: {
    isAdmin: state => {
      if (state.user !== null && state.user.roles.includes('ROLE_ADMIN')) {
        return true
      }
      return false
    },
    supplierCapabilities: state => connectorName => {
      const connector = state.connectors.filter(item => item.name === connectorName)
      if (connector.length === 1) {
        return connector[0].capabilities
      }
      return []
    },
    isSupplierCapableOf: state => ({ connectorName, capability }) => {
      const connector = state.connectors.filter(item => item.name === connectorName)
      if (connector.length === 1) {
        return connector[0].capabilities.includes(capability)
      }
      return false
    }
  }
})

export default store
